import React from 'react';
import { Instagram, Phone, Mail, MapPin } from 'lucide-react';
import { FOOTER } from '@/constants/testIds';

const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
};

const LINKS = [
    { id: 'home', label: 'Home' },
    { id: 'about', label: 'About' },
    { id: 'services', label: 'Services' },
    { id: 'portfolio', label: 'Portfolio' },
    { id: 'clients', label: 'Clients' },
    { id: 'gallery', label: 'Gallery' },
    { id: 'contact', label: 'Contact' },
];

const SERVICES = [
    'Corporate Events',
    'Event Production',
    'Artist Management',
    'Creative Productions',
    'MICE & Destination',
];

export const Footer = () => {
    return (
        <footer data-testid={FOOTER.root} className="relative bg-black border-t border-white/10">
            <div className="container-lux py-20">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
                    <div className="md:col-span-5">
                        <div className="mb-6">
                            <img
                                src="https://customer-assets.emergentagent.com/job_experience-craft-8/artifacts/ylt1lu9g_IMG_8022.png"
                                alt="Mindstorm Productions"
                                className="h-32 w-auto object-contain"
                                style={{ filter: 'invert(1) brightness(1.1) contrast(1.05)' }}
                            />
                        </div>
                        <p className="text-white/50 text-sm leading-relaxed max-w-md font-light mb-6">
                            An experiential event & creative production company designing, producing and delivering unforgettable brand experiences across India.
                        </p>
                        <a
                            href="https://instagram.com/mind.stormproductions"
                            target="_blank"
                            rel="noreferrer"
                            className="inline-flex items-center gap-2 text-gold hover:text-white text-sm transition-colors"
                        >
                            <Instagram size={16} /> @mind.stormproductions
                        </a>
                    </div>

                    <div className="md:col-span-2">
                        <div className="eyebrow mb-5">Explore</div>
                        <ul className="space-y-3">
                            {LINKS.map(l => (
                                <li key={l.id}>
                                    <button
                                        data-testid={FOOTER.link(l.id)}
                                        onClick={() => scrollTo(l.id)}
                                        className="text-white/60 hover:text-gold text-sm transition-colors"
                                    >
                                        {l.label}
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div className="md:col-span-2">
                        <div className="eyebrow mb-5">Services</div>
                        <ul className="space-y-3">
                            {SERVICES.map(s => (
                                <li key={s} className="text-white/60 text-sm">{s}</li>
                            ))}
                        </ul>
                    </div>

                    <div className="md:col-span-3">
                        <div className="eyebrow mb-5">Get in Touch</div>
                        <ul className="space-y-4 text-sm text-white/70 font-light">
                            <li className="flex items-start gap-3"><Phone size={14} className="text-gold mt-1 flex-shrink-0" /><a href="tel:+919986345269" className="hover:text-gold transition-colors">+91 9986345269</a></li>
                            <li className="flex items-start gap-3"><Mail size={14} className="text-gold mt-1 flex-shrink-0" /><a href="mailto:sanjay@mindstromproductions.com" className="hover:text-gold transition-colors break-all">sanjay@mindstromproductions.com</a></li>
                            <li className="flex items-start gap-3"><MapPin size={14} className="text-gold mt-1 flex-shrink-0" /> Bengaluru, Karnataka, India</li>
                        </ul>
                    </div>
                </div>
            </div>

            <div className="border-t border-white/5">
                <div className="container-lux py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
                    <div className="text-white/40 text-xs tracking-[0.2em] uppercase">
                        © {new Date().getFullYear()} Mindstorm Productions. All rights reserved.
                    </div>
                    <div className="text-white/30 text-xs tracking-[0.2em] uppercase">
                        Crafted in Bengaluru
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
